import React from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import { orderMethods } from "../../../../shared/constants/order";
import endpoints from "../../../../shared/constants/endpoints";
import { isMobile, routeCountryPath } from "../../../../shared/utilities/common";
import { goBackToMain } from "../../../../shared/utilities/store";
import orderDispatches from "../../../../shared/utilities/order-dispatches";
import { store } from "../../../../redux/store";
import * as userActions from "../../../../redux/actions/user";
import * as elementsActions from "../../../../redux/actions/elements";

export const SHIPPING_RETURN_BAR_HEIGHT = 48;

const isExcludedPath = (pathname) => {
  if (
    pathname === endpoints.locations ||
    pathname === endpoints.doughProPage
  ) {
    return true;
  }

  return (
    !!pathname.match(/login/g) ||
    !!pathname.match(/gifting/g) ||
    !!pathname.match(/contact/g) ||
    !!pathname.match(/create-account/g) ||
    !!pathname.match(/checkout\/review-order/g) ||
    !!pathname.match(endpoints.orderLoyaltyRegex)
  );
};

export const isShippingReturnBarVisible = ({
  showDeliveryPickupAddressBar,
  userOrderMethod,
  userAddress,
  showDeliveryPickupWidget,
  pathname,
}) => {
  if (!showDeliveryPickupAddressBar) {
    return false;
  }

  if (userOrderMethod !== orderMethods.shipping) {
    return false;
  }

  if (!pathname || isExcludedPath(pathname)) {
    return false;
  }

  return (
    !!userAddress ||
    showDeliveryPickupWidget ||
    pathname !== "/" ||
    isMobile()
  );
};

const ShippingReturnBar = ({
  orderProducts,
  userOrderMethod,
  showDeliveryPickupAddressBar,
  userAddress,
  showDeliveryPickupWidget,
  pathname,
}) => {
  const history = useHistory();

  if (
    !isShippingReturnBarVisible({
      showDeliveryPickupAddressBar,
      userOrderMethod,
      userAddress,
      showDeliveryPickupWidget,
      pathname,
    })
  ) {
    return null;
  }

  const handleReturnToDeliveryPickup = (e) => {
    e.preventDefault();

    if ((orderProducts || []).length > 0) {
      goBackToMain(history.push, routeCountryPath(endpoints.homePage));
    } else {
      orderDispatches(store, userActions, elementsActions);
      history.push(routeCountryPath(endpoints.homePage));
    }
  };

  return (
    <div className="bg-dark border-mainDark shadow-md">
      <div className="flex md:max-w-screen-desktop md:px-0 px-4 m-auto py-[6px] min-w-0 overflow-x-auto">
        <div className="md:flex gap-2 items-center flex-1 md:h-12 mr-2">
          <p>
            <button
              type="button"
              onClick={handleReturnToDeliveryPickup}
              tabIndex={0}
              onKeyDown={(e) =>
                e.key === "Enter" && handleReturnToDeliveryPickup(e)}
              className="rounded-40 py-2 px-4 border-[1px] border-solid border-darkDry text-white whitespace-nowrap"
            >
              Return to Delivery and Pickup
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

ShippingReturnBar.propTypes = {
  orderProducts: PropTypes.arrayOf(PropTypes.object),
  userOrderMethod: PropTypes.string,
  showDeliveryPickupAddressBar: PropTypes.bool,
  userAddress: PropTypes.shape({ address1: PropTypes.string }),
  showDeliveryPickupWidget: PropTypes.bool,
  pathname: PropTypes.string,
};

ShippingReturnBar.defaultProps = {
  orderProducts: [],
  userOrderMethod: null,
  showDeliveryPickupAddressBar: true,
  userAddress: null,
  showDeliveryPickupWidget: false,
  pathname: null,
};

export default ShippingReturnBar;
